import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { UserUrl } from './UserUrl';
import { UserDto } from '../schema';

export interface DataManagerSearchQueryParams {
  search: string;
}

const searchDataManagers = ({ search }: DataManagerSearchQueryParams) =>
  apiClient
    .get<Array<UserDto>>(expand(UserUrl.SEARCH_DATA_MANAGERS, { search }))
    .then((response) => response.data);

export const useSearchDataManagersQuery = createApiQueryHook(
  ['dataManagersAutocomplete'],
  searchDataManagers
);
